import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { environment } from "./../../../../../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  HandleError,
  HttpErrorHandler,
} from "src/app/shared/services/handle-error.service";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Observable, of } from "rxjs";
import { retry } from "rxjs/operators";
import { ConsultaMisRNTEntry } from "src/app/shared/entrys/consulta-mis-rnt.entry";
import { AuthService } from "src/app/shared/services/auth.service";
import { TipoPrestador } from "src/app/shared/enumeraciones/tipo-prestador.enum";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";

@Injectable()
export class EstablecimientoComercioSoloConsultaService
  implements RequestCRUD<EstablecimientoEntry, ResponseServiceModel> {
  private API_URL;
  private handleError: HandleError;
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private authService: AuthService,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.handleError = httpErrorHandler.createHandleError(
      "EstablecimientoComercioService"
    );
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: any): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  getRnt(
    entry: ConsultaMisRNTEntry,
    numeroPagina: number
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Rnt/ConsultarRntsPaginado?PageNumber=${numeroPagina}&PageSize=12`,
        entry
      )
      .pipe(retry(2));
  }

  // #region Filtros
  getTipoSolicitud(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/Solicitud/GetTipoSolicitudes`)
      .pipe(retry(2));
  }
  getSubCategorias(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/SubCategoria`)
      .pipe(retry(2));
  }
  getCamaras(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/CamaraComercio`)
      .pipe(retry(2));
  }
  getEstadosRNT(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/EstadosRnt`)
      .pipe(retry(2));
  }
  getEstadosSolicitud(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/EstadosSolicitud`)
      .pipe(retry(2));
  }

  descargarDocumento(entry: any): Observable<Blob> {
    return this.http
      .get<Blob>(
        `${this.API_URL}/sanciones/descargarDocumentoSancion/${entry.sancion_id}`
      )
      .pipe(retry(2));
  }

  getSancionesUsuario(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Sanciones/${entry.rnt_id}/GetByRntAnonymous`
      )
      .pipe(retry(2));
  }
  // #endregion
  update(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  create(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  delete(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
}
